<template>
  <div class="plv-ia-star">
    <div v-if="type === 'star'" class="plv-ia-star-type--star">
      <div v-for="(i, index) in maxStar"
           class="plv-ia-star-icon"
           :key="index"
           @click="chooseScore(index+1)">
        <div class="plv-ia-star-icon--active" :style="{width: percentage(index+1) + '%'}"></div>
      </div>
    </div>
    <div v-else-if="type === 'number'" class="plv-ia-star-type--number">
      <div v-for="(i, index) in 10" :key="index">
        {{ i }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StarComponent',
  props: {
    type: {
      type: String,
      default: 'star'
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxStar: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      currentValue: this.value > 0 ? this.value : 0
    };
  },
  methods: {
    chooseScore(val) {
      if (this.disabled) return;
      this.currentValue = val;
      this.$emit('update:value', val);
    },
    // 计算星星百分比
    percentage(index) {
      const { currentValue } = this;
      const val = (currentValue - index) / this.maxStar;
      if (val >= 0) {
        return 100;
      } else if (val < 0 && val > -1) {
        return Math.abs(val);
      } else {
        return 0;
      }
    }
  }
};
</script>

<style lang="scss">

.plv-ia-star-type--star {
  display: flex;
  .plv-ia-star-icon {
    position: relative;
    width: 24px;
    height: 24px;
    margin-right: 8px;
    background: url('./images/icon-star.svg') no-repeat;
  }
  .plv-ia-star-icon--active {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('./images/icon-star-active.svg') no-repeat;
  }
}
.plv-ia-star-type--number {
  display: flex;
  div {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #EDEDED;
    border-radius: 50%;
    margin-right: 8px;
    text-align: center;
  }
}

</style>
